// src/components/auth/ProtectedRoute.js
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function ProtectedRoute({ children, requiredRole = null, requiredModule = null }) {
  const { isAuthenticated, userProfile, hasRole, hasModuleAccess } = useAuth();
  const location = useLocation();

  // Not logged in — send to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Account inactive
  if (!userProfile?.active) {
    return <Navigate to="/inactive" replace />;
  }

  // Role check
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Module access check
  if (requiredModule && !hasModuleAccess(requiredModule)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

// Admin-only shorthand
export function AdminRoute({ children }) {
  return (
    <ProtectedRoute requiredRole="admin">
      {children}
    </ProtectedRoute>
  );
}

// Manager and above shorthand
export function ManagerRoute({ children }) {
  const { isManager } = useAuth();
  const location = useLocation();

  if (!isManager) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <ProtectedRoute>{children}</ProtectedRoute>;
}
